var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"author"},[_vm._v("微信授权登录中")])
}
var staticRenderFns = []

export { render, staticRenderFns }